/// <amd-module name="Search/Shared/Base/Sources/PageSource" />

import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { IVssPageService } from "VSS/Platform/Page";
import { serializeFilters, serializeSortOptions } from "Search/Shared/Utils";
import { EntitySortOption } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export class PageSource {
    constructor(private pageContext: IVssPageContext) { }

    public openUrlInNewtab(url: string): void {
        const newWindow = window.open(url, "_blank");
        if (newWindow && newWindow.opener) {
            newWindow.opener = null;
        }
    }

    public navigateToNewSearch = async (
        entityType: string,
        searchText: string,
        filters: { [key: string]: string[] },
        sortOptions?: EntitySortOption[]
    ): Promise<void> => {
        const pageData = this.pageContext.getService<ITfsPageService>("ITfsPageService").getData();
        const params: { [key: string]: string } = { type: entityType, text: searchText };
        const navigationService: IVssNavigationService = this.pageContext.getService<IVssNavigationService>("IVssNavigationService");

        if (filters) {
            params.filters = serializeFilters(filters);
        }

        if (pageData && pageData.project) {
            params.project = pageData.project.name;
        }

        if (sortOptions && sortOptions.length) {
            params.sortOptions = serializeSortOptions(sortOptions);
        }

        const currentRoute = navigationService.getCurrentRoute();
        const url = routeUrl(this.pageContext, currentRoute.routeId, params);
        this.openUrlInNewtab(url);
    }

    public openCollectionSearch = (entityType: string, searchText: string, includeFacets?: boolean): void => {
        const params: { [key: string]: string } = { type: entityType, text: searchText };
        if (includeFacets === false) {
            params.includeFacets = "false";
        }

        const url: string = routeUrl(this.pageContext, "ms.vss-search-web.collection-route", params);
        this.openUrlInNewtab(url);
    }


    public navigateToAccount = (accountName: string, searchText: string, entityType: string, filters?: { [key: string]: string[] }): void => {
        const params: { [key: string]: string } = { type: entityType, text: searchText };
        const navigationService = this.pageContext.getService<IVssNavigationService>("IVssNavigationService");
        const pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData();

        if (filters) {
            params.filters = serializeFilters(filters);
        }

        const currentRoute = navigationService.getCurrentRoute();
        const url: string = routeUrl(this.pageContext, currentRoute.routeId, params);
        if (pageData) {
            var regEx = new RegExp(pageData.hostName, "i");
            if (pageData.hostPath.toLowerCase().indexOf(pageData.hostName.toLowerCase()) >= 0) {
                const accountUrl: string = url.replace(regEx, accountName);
                this.openUrlInNewtab(accountUrl);
            }
            // Taking care of the old url (<host>.visualstudio.com) format here
            else {
                const locationUrl: string = window.location.origin.replace(pageData.hostName.toLowerCase(), accountName);
                const accountUrl: string = locationUrl.concat(url);
                this.openUrlInNewtab(accountUrl);
            }
        }
    }
}
